import { Dropdown, MenuProps } from 'antd';
import React, { useEffect, useState } from 'react';
import DropDownIcon from '../components/_DropDownIcon';


type Props = {
    message: any;
    isAdmin?: boolean;
    openMessage: Function;
    onMoveMessageClick: Function;
    onSetMessageClick: Function;
    onStarClick: Function;
    onDeleteMessage?: Function;
    onMessageCheck?: Function;
    actions: any[]
	// texts?: TextProps
};

const EmailMessageItem = (props: Props) => {
    const [message, setMessage] = useState(props.message);
    const [isRead, setIsRead] = useState<boolean>(!props.message.read);
    const [isStar, setIsStar] = useState<boolean>(props.message.star)
    const [isChecked, setIsChecked] = useState<boolean>(false)
    const [showBtnOptions, setShowBtnOptions ] = useState<boolean>(false);
    // console.log('props.message', props.message);

    const openMessage = () => {
        props.openMessage(message.id);
        setIsRead(true);
    }
    
    const onMoveMessage = () => {
        setShowBtnOptions(false);
        props.onMoveMessageClick(message.id)
    }
    const onSetMessage = () => {
        setShowBtnOptions(false);
        props.onSetMessageClick(message.id)
    }
    const onDeleteMessage = () => {
        setShowBtnOptions(false);
        if(props.isAdmin && props.onDeleteMessage) {
            props.onDeleteMessage(message.id)
        }
    }

    const onStarClick = async() => {
        // console.log('onStarClick')
        props.onStarClick(message.id);
        message.star = !message.star;
        setIsStar(!isStar);
        // await setMessage(message)
    }

    const onDropDownOptionClick = async (action: string) => {
        if (props.actions && props.actions.length > 0) {
            const propFunc = props.actions.find((a: any) => a.action === action);
            if (propFunc) {
                propFunc.callback(message.id);
                switch (action) {
                    case 'toggleReadMode':
                        const isReadMode = !isRead;
                        setIsRead(isReadMode);
                        break;
                
                    default:
                        break;
                }
            }
            // switch (action) {
            //     case 'setAsNotRead':
                    
            //         break;
            
            //     default:
            //         break;
            // }
        }
    }

    // const onOptionsBtnClick = () => {
    //     if (showBtnOptions) {
    //         setShowBtnOptions(false);
    //     } else {
    //         setShowBtnOptions(true);
    //     }
    // }

    const onMessageCheck = async() =>{
        console.log('onMessageCheck')
        if (props.onMessageCheck) {
            await setIsChecked(!message.checked);
            console.log('onMessageCheck', message.checked)
            props.onMessageCheck(message.id)
        }
    }

    
    const items: MenuProps['items'] = props.isAdmin ? 
    [
        {
            key: '1',
            label: (
                <li className="pointer rtl"
                    onClick={onSetMessage}
                >
                    שייך ל
                </li>
            ),
        },
        {
            label: 
                <li className="pointer rtl"
                    onClick={onMoveMessage}
                >
                    העבר לתקיה
                </li>,
            key: '2',
        },
        {
            label: 
                <li className="pointer rtl"
                    onClick={()=>onDropDownOptionClick('toggleReadMode')}
                >
                    {!isRead ? 'סמן כנקרא' : 'סמן כלא נקרא'}
                </li>,
            key: 'toggleReadMode',
        },
        {
            label: 
                <li className="pointer rtl"
                    onClick={onDeleteMessage}
                >
                    מחק
                </li>,
            key: '3'
        }
    ] : 
    [
        {
            key: '1',
            label: (
                <li className="pointer rtl"
                    onClick={onSetMessage}
                >
                    שייך ל
                </li>
            ),
        },
        {
            label: 
                <li className="pointer rtl"
                    onClick={onMoveMessage}
                >
                    העבר לתקיה
                </li>,
            key: '2',
        },
        {
            label: 
                <li className="pointer rtl"
                    onClick={()=>onDropDownOptionClick('toggleReadMode')}
                >
                    {!isRead ? 'סמן כנקרא' : 'סמן כלא נקרא'}
                </li>,
            key: 'toggleReadMode',
        }
    ];

    useEffect(()=>{
        setMessage(props.message);
        setIsRead(!props.message.read);
        setIsStar(props.message.star);
        setIsChecked(props.message.checked);
        console.log('message init', props.message);
    }, [props.message])

    return (
        <>
        <div className={`data-card client-item ${isRead?'read':'unread'}`} key={message.id}>
            <div className="data-card-body flex-start pointer">
                <div className="cell checkbox">
                    <input type="checkbox" className="check-email" checked={isChecked} onChange={onMessageCheck} />
                    <div className={`icon star pointer ${isStar ? 'selected' : ''}`} onClick={(e:any)=>onStarClick()}></div> 
                </div>
                <div onClick={(e: any)=>openMessage()} className="flex-centered flex-grow flex-start">
                    <div className="cell">
                        {/* <div className="title">שם</div> */}
                        <div className="description cell-value">
                            {message.from}
                        </div>
                    </div>
                    <div className="cell long description">
                        {/* <div className="title">ח.פ / ת.ז</div> */}
                        <div className="description cell-value">
                            {message.subject}
                        </div>
                    </div>
                    <div className="cell checkbox">
                        {props.message.attachments && (
                            <>
                            <div className="icon paperclip"></div> 
                            {/* 1 */}
                            </>
                        )}
                    </div>
                    <div className="cell">
                        <div className="title">תאריך</div>
                        <div className="description cell-value">
                            <div>
                            {message.date} 
                            </div>
                            <div>
                            {message.time}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cell action">
                    <Dropdown menu={{ items }}>
                        <div className='act-btn-icon icon menu-hamburger pointer'></div>
                    </Dropdown>
                    {/* <DropDownIcon onOptionClick={(action: string, value?: string)=>this.onMenuClick(action, value)} options={[
                        {
                            key: 'sendToEmail',
                            label: 'שליחה ללקוח מייל',
                            hide: this.props.emailAddress == ''
                        },
                        {
                            key: 'sendToWhatsApp',
                            label: 'שליחה בוואטס אפ',
                            hide: false
                        },
                        {
                            key: 'createRider',
                            label: 'יצירת מנוי',
                            hide: !this.state.hideCreateRiderOption
                        }
                    ]} /> */}
                    {/* <button className="act-btn" onClick={()=>onOptionsBtnClick()}>
                        פעולות
                    </button>
                    {showBtnOptions && (<ul className="btn-menu">
                        <li className="pointer"
                            onClick={()=>onSetMessage()}
                        >
                            שייך ל
                        </li>
                        <li className="pointer"
                            onClick={()=>onMoveMessage()}
                        >
                            העבר לתקיה
                        </li>
                        {
                            props.isAdmin ? (<>
                                <li className="pointer"
                                    onClick={()=>onDeleteMessage()}
                                >
                                    מחק
                                </li>
                            </>) : (<></>)
                        }
                    </ul>)} */}
                </div>
            </div>
            
        </div>
        </>
    )
}

export default EmailMessageItem;